import React from 'react';
import PropTypes from 'prop-types';
import styles from './Loader.module.scss';

const Loader = ({ children }) => (
  <div className={styles.withLoader}>
    <div className={styles.loader} />
    {children}
  </div>
);

Loader.propTypes = {
  children: PropTypes.shape().isRequired,
};

export default Loader;
